import * as React from 'react';
import { Avatar, SxProps, Typography, Box } from '@mui/material';
import { FieldProps, TextField, useRecordContext } from 'react-admin';
import { Client } from '../types';

interface Props extends FieldProps<Client> {
    sx?: SxProps;
    size?: string;
}

const UserProfileField = ({ size = '25', sx }: Props) => {
    const record = useRecordContext<Client>();
    if (!record) return null;

    return (
        <Box sx={{display: 'flex', justifyContent: 'right', marginBottom: '10px'}}>
            <Avatar
                src={`${record.avatar_url}?size=${size}x${size}`}
                imgProps={{
                    referrerPolicy: "no-referrer"
                }}
                style={{ width: parseInt(size, 10), height: parseInt(size, 10) }}
                sx={sx}
            />
            <Typography sx={{paddingLeft: '10px'}}>{record.name}</Typography>
        </Box>
    );
};

export default UserProfileField;


